import { ListeningModeStoreState, ListeningOwnership, useListeningModeStore } from '../listeningModeStore';

export const getIsOnSharedListeningMode = (state?: ListeningModeStoreState) => {
  return (state ?? useListeningModeStore.getState()).ownership === ListeningOwnership.SHARED;
};
